module.exports = __webpack_public_path__ + "img/logo-small.c10a15a9.png";